import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=20511c3a&scoped=true&"
import script from "./usage.vue?vue&type=script&lang=js&"
export * from "./usage.vue?vue&type=script&lang=js&"
import style0 from "./usage.vue?vue&type=style&index=0&id=20511c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20511c3a",
  null
  
)

component.options.__file = "usage.vue"
export default component.exports